module.exports = {
  publicPath: '/fleetadmin/',
  transpileDependencies: ['pdfjs-dist'],
}